<script>
import { Line } from 'vue-chartjs'

export default {
  name: 'MetricasChart',
  extends: Line,
  props: {
    chartData: {
      type: Object,
      required: true,
      default: () => ({
        labels: [],
        datasets: [],
      }),
    },
    options: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    height: {
      type: Number,
      default: 300,
    },
  },
  watch: {
    chartData: {
      handler() {
        this.$data._chart.destroy()
        this.renderChart(this.chartData, this.options)
      },
      deep: true,
    },
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
}
</script>
